import React, { useState, useEffect, useRef } from "react";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TablePagination from "@mui/material/TablePagination";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import { themes, scrollTop } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { tableRowSx } from "services/constants";
import { InfoMessage } from "components/CustomComponents/CustomButton";

export const Approved = () => {
  const { domain, token, userDetails, globalSearchValue } = useSelector(
    (state) => state.tokenReducer
  );
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = React.useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [rejectOt, setRejectOt] = useState([]);
  const containerRef = useRef(null);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  const handleStartDate = async (startDate, endDate) => {
    let searchStartDate = startDate.split("/").reverse().join("-");
    let searchEndDate = endDate.split("/").reverse().join("-");
    setLoading(true);
    try {
      const response = await fetch(
        `${domain}week-off-approvals/?selected_user_id=${userDetails.id}&status=Rejected&start_date=${searchStartDate}&end_date=${searchEndDate}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        setFilteredData(res);
        setRejectOt(res);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
      setLoading(false);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    const searchFields = [
      "user_name",
      "date",
      "shift_name",
      "check_in_datetime",
      "check_out_datetime",
      "rejectedby",
      "rejectedat",
    ];
    const filteredResults = rejectOt.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setFilteredData(filteredResults);
    setPage(0);
  }, [globalSearchValue, rejectOt]);

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={9.25}></Grid>
        <Grid item xs={2.6} sx={{ paddingTop: 1, marginTop: -7 }}>
          <BSDateRangePicker
            handleStartDate={handleStartDate}
            showToday={true}
            triggerDate={true}
          />
        </Grid>
      </Grid>

      {loading === true ? (
        <Loader info="Loading..." />
      ) : (
        <>
          <Grid container>
            <TableContainer
              sx={{
                marginTop: 3,
                marginLeft: "auto",
                marginRight: "auto",
                overflow: "auto",
                ml: 2,
                mr: 2,
              }}
            >
              <Table className="border">
                <TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <TableRow sx={tableRowSx}>
                    <TableCell></TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Employee name</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Date</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Shift Name</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Check-in</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Check-out</Typography>
                    </TableCell>

                    <TableCell>
                      <Typography fontWeight="bold">Rejected by</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight="bold">Rejected At</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData?.length === 0 ? (
                    <InfoMessage dataLength={rejectOt} />
                  ) : (
                    filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item) => (
                        <>
                          <TableRow sx={tableRowSx}>
                            <TableCell>
                              {expandedRow === item.id ? (
                                <IconButton
                                  onClick={() => {
                                    setExpandedRow(null);
                                  }}
                                >
                                  <KeyboardArrowDownIcon
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() => handleRowClick(item.id)}
                                >
                                  <KeyboardArrowRightIcon
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell key={item.id}>
                              {item.user_name ? item.user_name : "N/A"}
                            </TableCell>
                            <TableCell>{item?.date}</TableCell>
                            <TableCell>
                              {" "}
                              {item.shift_name ? item.shift_name : "N/A"}
                            </TableCell>
                            <TableCell>{item.check_in_datetime}</TableCell>
                            <TableCell>{item.check_out_datetime}</TableCell>
                            <TableCell>
                              {item.rejectedby ? item.rejectedby : "N/A"}
                            </TableCell>
                            <TableCell>
                              {item.rejectedat ? item.rejectedat : "N/A"}
                            </TableCell>
                          </TableRow>
                          {expandedRow === item.id && (
                            <TableRow>
                              <TableCell colSpan={9}>
                                <TableContainer
                                  sx={{
                                    marginTop: 0.5,
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    width: "100%px",
                                  }}
                                  className="w-96 border rounded"
                                >
                                  <Table className="border">
                                    <Typography
                                      variant="body1"
                                      gutterBottom
                                      sx={{ marginLeft: 1, marginTop: 0.5 }}
                                    >
                                      <strong>Reason for Rejection :</strong>{" "}
                                      <Typography
                                        fontSize={15}
                                        color="textSecondary"
                                        sx={{ marginLeft: 13 }}
                                      >
                                        {item.reason}
                                      </Typography>
                                    </Typography>
                                  </Table>
                                </TableContainer>
                                {item.title === "Leave" ? null : (
                                  <TableContainer
                                    sx={{
                                      marginTop: 0.5,
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                      width: "100%px",
                                    }}
                                    className="w-96 border rounded"
                                  >
                                    <Table className="border">
                                      <Typography
                                        variant="body1"
                                        gutterBottom
                                        sx={{ marginLeft: 1, marginTop: 0.5 }}
                                      >
                                        <strong>
                                          Time Period : {item.check_in_datetime}{" "}
                                          to {item.check_out_datetime}
                                        </strong>
                                      </Typography>
                                    </Table>
                                  </TableContainer>
                                )}
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          {filteredData.length > 25 && (
            <TablePagination
              className="custom-pagination"
              rowsPerPageOptions={[25, 50, 75, 100]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};
